import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { useIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';

import InputFieldComponent from '../../../Common/FormField/InputFieldComponent';
import messages from '../../../../locale/messages';
import validate from './validate';
import { createSmtpData } from '../../../../actions/siteadmin/SmtpSetup/manageSmtpData';
import { smtpSetupForm } from '../../../../helpers/SmtpSetup/smtpSetupForm'
import { encode } from '../../../../helpers/queryEncryption';
import getSMTPToolTipType from '../../../../helpers/toolTipContent';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

import s from './SMTPForm.css';
import bt from '../../../../components/commonStyle.css';

const SMTPForm = (props) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { handleSubmit, submitting, error, paginationData, currentPage } = props;
  const id = useSelector((state) => formValueSelector('SMTPForm')(state, 'id'));
  const formFields = smtpSetupForm();

  const onSubmit = async (values) => {
    if (values?.id) {
      const isRestrict = await dispatch(demoRestriction({ restrictType: 'SMTP', restrictValue: values?.id }));
      if (isRestrict) return;
    }
    await dispatch(
      createSmtpData({
        id: values?.id,
        smtpName: values?.smtpName,
        smtpHost: encode(values?.smtpHost),
        smtpPort: encode(values?.smtpPort),
        smtpEmail: encode(values?.smtpEmail),
        smtpSender: encode(values?.smtpSender),
        smtpSenderEmail: encode(values?.smtpSenderEmail),
        smtpPassword: encode(values?.smtpPassword),
        currentPage,
      })
    );

    if (!values?.id) {
      paginationData(1);
    }
  };

  return (
    <div className={cx(s.formMaxWidth, 'maxwidthcenter', 'empty')}>
      <form onSubmit={handleSubmit(onSubmit)}>
        {error && <strong>{intl.formatMessage(error)}</strong>}

        {formFields?.map((item, index) => (
          <FormGroup key={index} className={s.space3}>
            <Field
              name={item.name}
              type="text"
              component={InputFieldComponent}
              inputClass={cx(bt.commonControlInput)}
              label={intl.formatMessage(messages[item.name])}
              placeholder={intl.formatMessage(messages[item.placeHolder])}
              infoText={getSMTPToolTipType(item.name, intl.formatMessage)}
              showToolTip={true}
            />
          </FormGroup>
        ))}

        <FormGroup className={s.formGroup}>
          <div className={cx(bt.textAlignRight, 'textAlignLeftRtl')}>
            <Button className={cx(bt.btnPrimary, bt.btnLarge)} type="submit" disabled={submitting}>
              {id ? <FormattedMessage {...messages.update} /> : <FormattedMessage {...messages.addLabel} />}
            </Button>
          </div>
        </FormGroup>
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'SMTPForm',
  validate,
})(withStyles(s, bt)(SMTPForm));
